<template>
  <svg width="232" height="200" viewBox="0 0 232 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M230.415 116.083C229.055 111.393 226.868 106.64 223.675 102.014C214.157 88.3317 198.786 78.3747 193.229 61.737C186.726 42.4013 186.134 20.8814 168.931 8.29069C133.518 -17.4689 98.1058 22.6801 75.8178 48.6324C67.8959 57.8827 57.2081 61.737 47.5588 70.6661C21.2444 89.7622 18.4067 127.688 21.2444 141.564C25.501 162.377 34.2706 172.94 47.5588 182.481C75.8178 194.574 83.2605 199.21 103.72 199.21C118.871 199.21 147.117 184.655 200.382 167.73C223.025 160.536 236.859 138.63 230.415 116.083Z"
      fill="#1B365D"
      class="fill-primary-800"
      fill-opacity="0.1"
    />
    <mask id="mask0_28_20716" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="232" height="200">
      <path
        d="M230.414 116.083C229.055 111.393 226.867 106.64 223.675 102.014C214.157 88.3317 198.786 78.3747 193.228 61.737C186.725 42.4013 186.134 20.8814 168.93 8.29069C133.518 -17.4689 98.1054 22.6801 75.8175 48.6324C67.8955 57.8827 58.6729 66.4264 47.5585 70.6661C22.2554 80.3019 21.889 73.043 6.87271 102.014C0.428711 114.412 -1.58134 129.444 1.25639 143.32C5.51297 164.133 6.87273 159.637 13.2693 175.439C36.5623 179.1 64.533 198.594 88.0034 198.337C112.003 207.004 163.491 179.55 200.382 167.73C223.024 160.536 236.858 138.63 230.414 116.083Z"
        fill="#1B365D"
        class="fill-primary-800"
      />
    </mask>
    <g mask="url(#mask0_28_20716)">
      <path
        d="M117.327 134.485C128.341 135.388 134.732 104.157 150.777 134.485C166.686 164.812 139.899 199.398 95.5704 199.915C95.5704 199.915 82.7886 198.624 91.899 186.88C91.899 186.88 88.0917 158.747 88.6356 142.744C89.1795 126.742 105.089 118.74 111.888 121.063C118.822 123.257 106.313 133.581 117.327 134.485Z"
        fill="#7089AC"
        class="fill-primary-400"
      />
      <path
        d="M84.1497 135.899C73.5435 129.059 65.1129 160.935 82.79 170.485C100.603 179.906 95.7078 143.384 84.1497 135.899Z"
        fill="#7089AC"
        class="fill-primary-400"
      />
      <path d="M81.973 144.031L109.712 145.193L114.764 195.243L87.9333 194.033L81.973 144.031Z" fill="#F9F9F9" />
      <path
        d="M79.6617 134.349C82.1093 124.153 93.9393 152.803 85.6447 153.19C77.3501 153.577 77.758 141.963 79.6617 134.349Z"
        fill="#F48682"
      />
      <path
        d="M92.3069 189.715C92.3069 189.715 78.1653 182.101 75.8537 190.747C73.5421 199.394 78.7092 198.49 92.3069 194.232C106.041 189.844 92.3069 189.715 92.3069 189.715Z"
        fill="#F48682"
      />
      <path
        d="M92.4439 183.782C80.478 181.975 81.5658 204.688 112.161 197.977C142.891 191.267 149.282 173.974 150.914 170.489C152.546 167.005 133.781 155.906 133.781 155.906C133.781 155.906 106.858 185.847 92.4439 183.782Z"
        fill="#7089AC"
        class="fill-primary-400"
      />
      <path
        d="M107.265 88.151C106.313 96.7975 110.8 104.412 117.463 105.057C123.99 105.702 130.245 99.2495 131.197 90.4739C132.149 81.8274 127.661 74.2133 120.998 73.568C114.472 73.0518 108.217 79.5044 107.265 88.151Z"
        fill="#F48682"
      />
      <path
        d="M108.08 126.737C109.712 132.286 111.751 137.319 113.791 137.577C119.502 138.093 128.613 128.414 133.78 122.349L127.117 100.668L114.063 101.055C114.063 101.055 114.199 102.346 114.199 104.281C114.199 104.669 114.199 105.185 114.199 105.701C114.335 111.637 113.519 121.962 108.08 126.737Z"
        fill="#F48682"
      />
      <path
        d="M114.197 104.152C114.197 105.174 114.197 106.535 114.197 107.897C117.579 107.556 123.406 102.661 123.542 102.32C121.512 104.363 115.956 104.493 114.197 104.152Z"
        fill="#F48682"
      />
      <path
        d="M110.664 71.7628C111.48 80.1512 120.046 73.1823 125.213 83.7647C130.516 94.347 131.196 108.543 138.403 94.0889C145.746 79.635 143.026 76.6668 138.403 74.4729C133.78 72.279 160.295 74.9891 142.074 60.2771C131.468 51.7596 126.165 67.504 126.165 67.504C126.165 67.504 109.984 65.1811 110.664 71.7628Z"
        fill="#232057"
      />
      <path
        d="M140.17 83.375C140.034 83.375 139.899 83.375 139.899 83.375C140.034 83.375 140.034 83.5037 140.17 83.5037V83.375Z"
        fill="#202A44"
      />
      <path
        d="M138.812 81.8268C138.132 81.3106 137.316 80.6654 136.636 80.1492C136.364 79.8911 136.092 79.762 135.684 79.5039C135.684 79.762 135.82 79.8911 136.092 80.0201C136.228 80.1492 136.5 80.1492 136.636 80.2782C136.908 80.5363 137.18 80.7944 137.588 81.0525C137.588 81.3106 137.86 81.1816 137.86 81.3106C137.996 81.6978 138.404 81.6978 138.676 81.9559C138.812 82.085 139.084 82.214 139.22 82.3431C139.628 82.6012 139.899 82.9883 140.307 83.3755C140.579 83.6336 140.715 83.7626 140.987 84.0207C141.123 84.0207 141.259 84.0207 141.395 84.0207C141.259 83.8917 141.123 83.7626 140.987 83.6336C140.851 83.6336 140.715 83.6336 140.579 83.5045V83.3755C140.307 83.1174 140.035 82.9883 139.899 82.7302C139.492 82.3431 139.084 82.085 138.812 81.8268Z"
        fill="#202A44"
      />
      <path
        d="M134.596 78.5943C135.956 79.3687 137.315 80.4011 138.539 81.3045C138.539 81.3045 138.675 81.3044 138.811 81.4335C138.675 81.3044 138.539 81.1754 138.403 81.0463C138.267 80.9173 137.995 80.9173 137.995 80.6592L137.859 80.5301C137.451 80.4011 137.179 80.143 136.908 79.8849C136.228 79.3687 135.548 78.8524 134.732 78.4653C134.596 78.3362 134.46 78.2072 134.324 78.2072C134.188 78.2072 134.052 78.2072 133.916 78.0781C134.052 78.3362 134.324 78.4653 134.596 78.5943Z"
        fill="#202A44"
      />
      <path
        d="M128.613 83.116C128.749 83.116 128.749 83.245 128.749 83.245C128.885 83.245 129.021 83.245 129.157 83.3741C129.157 83.5031 129.293 83.5031 129.428 83.5031C129.293 83.3741 129.021 83.116 128.613 83.116C128.749 83.116 128.749 82.9869 128.613 83.116Z"
        fill="#202A44"
      />
      <path
        d="M134.868 94.9883C135.004 95.117 135.14 95.117 135.276 95.2457C135.14 94.9883 135.14 94.9883 134.868 94.9883Z"
        fill="#202A44"
      />
      <path
        d="M137.316 94.4717C137.044 94.4717 136.908 94.2136 136.636 94.4717C136.636 94.4717 136.5 94.4717 136.364 94.4717C135.684 94.2136 135.005 94.0845 134.461 93.8264C134.461 93.8264 134.325 93.9555 134.189 93.9555C134.053 93.9555 134.053 93.8264 134.053 93.8264C133.781 93.8264 133.645 93.8264 133.509 93.8264C133.101 93.6974 132.693 93.5683 132.421 93.4393C132.285 93.4393 132.149 93.3102 132.149 93.4393C132.285 93.6974 132.285 93.6974 132.421 93.6974C133.645 94.0845 134.733 94.4717 136.092 94.7298C136.364 94.7298 136.636 94.8588 137.044 94.8588C137.18 94.9879 137.18 94.9879 137.316 94.8588C137.588 94.8588 137.86 94.9879 138.132 94.9879C138.268 94.7298 138.404 94.6007 138.404 94.3426C138.268 94.2136 138.268 94.2136 138.132 94.0845C138.268 94.0845 138.404 94.0845 138.54 94.0845C138.54 93.9555 138.54 93.9555 138.676 93.8264C138.676 93.8264 138.676 93.8264 138.54 93.8264C137.996 93.8264 137.452 93.6974 137.044 93.3102C136.908 93.1812 136.772 93.0521 136.636 93.0521C136.092 92.6649 135.684 92.2778 135.141 91.8906V92.0197C135.549 92.4068 136.092 92.794 136.5 93.0521C136.636 93.1812 136.908 93.3102 137.044 93.5683C136.908 93.5683 136.772 93.5683 136.636 93.5683C136.092 93.4393 135.549 93.3102 135.005 93.1812C134.869 93.1812 134.733 93.1812 134.597 93.1812C134.461 93.1812 134.325 93.0521 134.189 93.0521C134.053 93.0521 133.917 92.9231 133.781 92.9231C133.645 93.0521 133.509 92.9231 133.373 92.9231C132.965 92.794 132.421 92.6649 132.013 92.4068C131.605 92.2778 131.197 92.1487 130.653 92.0197C130.789 92.0197 130.789 92.1487 130.925 92.1487C131.605 92.4068 132.285 92.5359 133.101 92.794C133.373 92.923 133.645 92.794 133.645 93.0521H133.781C133.917 93.0521 133.917 93.0521 134.053 93.0521C134.733 93.3102 135.548 93.4393 136.228 93.5683H136.364C136.364 93.5683 136.364 93.5683 136.364 93.6974C136.364 93.6974 136.364 93.6974 136.5 93.5683C136.908 93.6974 137.316 93.8264 137.724 94.0845L137.86 94.2136C137.588 94.2136 137.452 94.2136 137.18 94.3426C137.452 94.4717 137.452 94.4717 137.316 94.4717Z"
        fill="#202A44"
      />
      <path
        d="M125.35 73.4387C121.543 71.632 117.599 70.3415 113.52 69.0509C113.384 69.0509 113.112 68.9219 112.976 68.9219C113.112 69.18 113.248 69.18 113.52 69.18C114.336 69.309 115.016 69.5671 115.832 69.8252C116.104 69.9543 116.376 70.0834 116.783 70.2124C117.463 70.3415 118.143 70.5996 118.823 70.8577C118.823 70.8577 118.823 70.8577 118.959 70.8577C119.095 70.8577 119.095 70.8577 119.231 70.9867C119.503 71.3739 119.639 71.5029 119.911 71.2448C120.047 71.2448 120.183 71.3739 120.319 71.3739C121.135 71.632 121.951 72.0191 122.63 72.2772C123.31 72.5354 123.99 72.7935 124.534 73.0516C124.67 73.0516 124.67 73.0516 124.806 73.1806C124.806 73.3097 125.078 73.3097 125.35 73.4387C125.214 73.4387 125.214 73.4387 125.35 73.4387Z"
        fill="#202A44"
      />
      <path
        d="M135.14 91.5084C134.868 91.3793 134.732 91.1212 134.461 90.9922C134.597 91.3793 134.868 91.5084 135.14 91.5084Z"
        fill="#202A44"
      />
      <path
        d="M137.451 95.8953C137.451 95.8953 137.451 95.7662 137.587 95.7662H137.451C136.907 95.6372 136.227 95.3791 135.684 95.25C135.548 95.25 135.412 95.25 135.412 95.25C135.548 95.25 135.684 95.3791 135.82 95.3791C136.227 95.5081 136.771 95.7662 137.451 95.8953Z"
        fill="#202A44"
      />
      <path
        d="M122.358 72.6613C121.542 72.2742 120.59 72.0161 119.774 71.6289C119.91 71.887 120.182 72.0161 120.454 72.1451C121.134 72.4032 121.814 72.6613 122.494 72.9194C122.902 73.0485 123.174 73.1775 123.582 73.4356C123.582 73.3066 123.582 73.3066 123.582 73.1775C123.174 72.9194 122.766 72.7904 122.358 72.6613Z"
        fill="#202A44"
      />
      <path
        d="M138.539 90.8594C138.539 90.9868 138.674 90.9868 138.539 90.8594C138.674 90.9868 138.674 90.9869 138.674 90.9869C138.674 90.9869 138.674 90.8594 138.539 90.8594Z"
        fill="#202A44"
      />
      <path
        d="M130.244 83.895C130.516 84.024 130.788 84.2821 130.924 84.4112C131.604 84.9274 132.284 85.4436 133.1 85.9598C133.372 86.0889 133.644 86.347 133.916 86.476C133.916 86.347 133.916 86.347 133.78 86.2179C132.828 85.5727 132.012 84.7983 131.06 84.2821C130.652 84.024 130.244 83.7659 129.836 83.5078C129.836 83.5078 129.7 83.5078 129.564 83.5078C129.7 83.6369 129.972 83.7659 130.244 83.895Z"
        fill="#202A44"
      />
      <path
        d="M123.852 80.1483C123.717 80.1483 123.717 80.0195 123.581 80.0195C123.445 80.0195 123.173 80.0195 123.037 80.0195C123.037 80.0195 123.037 80.0195 123.173 80.0195C123.309 80.1483 123.581 80.1483 123.852 80.1483Z"
        fill="#202A44"
      />
      <path
        d="M141.532 82.7267C141.803 82.9848 142.211 83.372 142.483 83.6301C142.483 83.501 142.483 83.501 142.483 83.372C142.211 83.1139 141.939 82.8558 141.668 82.5977C141.668 82.7267 141.668 82.7267 141.532 82.7267Z"
        fill="#202A44"
      />
      <path
        d="M127.662 82.2186C127.526 82.2186 127.526 82.0898 127.391 82.0898C127.391 82.2186 127.526 82.2186 127.662 82.2186Z"
        fill="#202A44"
      />
      <path
        d="M133.508 77.5708C133.372 77.4417 133.372 77.4417 133.372 77.3126C133.1 77.4417 133.1 77.4417 132.828 77.1836C132.692 77.1836 132.692 77.1836 132.556 77.1836C132.692 77.1836 132.692 77.3126 132.828 77.3126C133.372 77.5708 133.78 77.9579 134.324 78.216C134.46 78.216 134.596 78.216 134.732 78.216C134.868 78.216 134.868 78.216 135.004 78.216C134.46 77.9579 134.052 77.6998 133.508 77.5708C133.644 77.5708 133.644 77.5708 133.508 77.5708Z"
        fill="#202A44"
      />
      <path
        d="M126.574 74.599C126.71 74.728 126.71 74.728 126.845 74.728C126.845 74.728 126.845 74.728 126.981 74.728C127.117 74.728 127.389 74.8571 127.525 74.8571C127.525 74.8571 127.525 74.8571 127.661 74.8571C127.525 74.728 127.253 74.728 127.117 74.599C126.574 74.3409 126.03 74.0828 125.35 73.9537C125.078 73.8247 124.806 73.6956 124.67 73.5666C124.398 73.5666 123.99 73.4375 123.718 73.4375C124.126 73.5666 124.534 73.8247 124.942 73.9537C125.486 74.2118 125.894 74.3409 126.438 74.599C126.438 74.4699 126.574 74.4699 126.574 74.599Z"
        fill="#202A44"
      />
      <path
        d="M132.011 76.537C131.877 76.4095 131.877 76.4095 132.011 76.537C131.877 76.537 131.877 76.537 132.011 76.537C132.011 76.537 131.877 76.537 132.011 76.537Z"
        fill="#202A44"
      />
      <path
        d="M126.165 73.7029C126.029 73.7029 125.894 73.5742 125.622 73.5742C125.894 73.7029 126.029 73.7029 126.165 73.7029Z"
        fill="#202A44"
      />
      <path
        d="M124.534 73.569C124.67 73.569 124.942 73.569 125.078 73.6981C125.35 73.8271 125.622 73.8271 126.029 73.9562C125.894 73.8271 125.758 73.8271 125.758 73.6981C125.622 73.569 125.35 73.569 125.214 73.569C125.214 73.569 125.214 73.569 125.078 73.569C124.942 73.569 124.806 73.44 124.67 73.44C124.534 73.3109 124.262 73.3109 124.126 73.1819C123.854 72.9238 123.718 72.9238 123.718 73.1819C123.99 73.3109 124.262 73.3109 124.534 73.569C124.534 73.569 124.534 73.44 124.534 73.569Z"
        fill="#202A44"
      />
      <path
        d="M132.148 77.1836C132.012 77.1836 131.876 77.1836 131.74 77.1836C132.148 77.4417 132.556 77.5708 132.964 77.8289L133.1 77.9579C133.236 77.9579 133.236 77.9579 133.372 77.9579C133.508 77.9579 133.644 77.9579 133.78 78.087C133.372 77.8289 132.964 77.5708 132.42 77.3126C132.284 77.3126 132.284 77.3126 132.148 77.1836Z"
        fill="#202A44"
      />
      <path
        d="M132.285 77.824C132.421 77.824 132.556 77.824 132.556 77.824C132.556 77.824 132.556 77.824 132.556 77.6953C132.421 77.824 132.285 77.824 132.285 77.824Z"
        fill="#202A44"
      />
      <path
        d="M126.574 74.082C126.438 74.082 126.438 74.082 126.574 74.082C126.71 74.2111 127.117 74.3401 127.389 74.4692C127.117 74.3401 126.845 74.2111 126.574 74.082Z"
        fill="#202A44"
      />
      <path
        d="M128.069 74.4688C128.204 74.4688 128.34 74.5975 128.476 74.5975C128.34 74.5975 128.204 74.4688 128.069 74.4688Z"
        fill="#202A44"
      />
      <path
        d="M130.653 76.0145C130.789 76.0145 130.789 76.1432 130.925 76.1432C131.197 76.1432 131.468 76.1432 131.604 76.1432C131.468 76.1432 131.333 76.0145 131.197 76.0145C131.061 75.8858 130.925 75.8858 130.653 76.0145Z"
        fill="#202A44"
      />
      <path
        d="M126.437 74.0817C126.301 73.9529 126.165 73.9529 126.029 73.8242C126.165 73.9529 126.301 74.0817 126.437 74.0817Z"
        fill="#202A44"
      />
      <path
        d="M129.837 75.759C129.837 75.888 129.837 75.888 129.701 75.888C129.837 76.0171 130.109 76.1461 130.245 76.1461C130.789 76.4042 131.468 76.7914 132.012 77.0495C132.148 77.0495 132.148 77.0495 132.284 77.0495H132.42C131.74 76.6624 131.197 76.4042 130.517 76.0171C130.381 75.888 130.245 75.888 129.973 75.759C130.109 75.759 130.109 75.6299 130.245 75.6299C130.109 75.759 129.973 75.6299 129.837 75.759C129.837 75.6299 129.701 75.6299 129.701 75.6299C129.157 75.2428 128.341 74.9847 127.797 74.7266L127.933 74.8556C127.797 74.8556 127.797 74.8556 127.797 74.8556C128.477 75.2428 129.157 75.5009 129.837 75.888C129.701 75.888 129.701 75.759 129.837 75.759Z"
        fill="#202A44"
      />
      <path
        d="M127.662 74.5975C127.526 74.4687 127.526 74.4688 127.391 74.4688C127.391 74.4688 127.526 74.5975 127.662 74.5975Z"
        fill="#202A44"
      />
      <path
        d="M128.34 82.5977C128.204 82.5977 128.204 82.5977 128.069 82.5977C128.34 82.7267 128.476 82.8558 128.748 82.9848C128.748 82.9848 128.748 82.8558 128.884 82.8558C128.612 82.7267 128.476 82.5977 128.34 82.5977Z"
        fill="#202A44"
      />
      <path
        d="M134.188 63.7587C133.78 63.3715 133.372 63.2425 132.964 62.9844C132.964 63.1134 132.964 63.3715 133.236 63.3715C133.508 63.6296 133.78 63.7587 134.188 63.7587Z"
        fill="#202A44"
      />
      <path
        d="M132.964 63.7578C133.372 64.0159 133.78 64.274 134.324 64.4031C133.916 64.0159 133.372 64.0159 132.964 63.7578Z"
        fill="#202A44"
      />
      <path
        d="M134.321 63.1119C134.321 63.1119 134.187 63.1118 134.187 62.9844C134.187 62.9844 134.187 62.9844 134.187 63.1119C134.053 63.1119 134.187 63.1119 134.321 63.1119C134.321 63.1119 134.187 63.2393 134.321 63.1119Z"
        fill="#202A44"
      />
      <path
        d="M135.548 63.4961C135.82 63.6251 136.228 63.7542 136.499 64.0123C136.363 63.6251 135.956 63.4961 135.548 63.4961C135.684 63.4961 135.684 63.4961 135.548 63.4961Z"
        fill="#202A44"
      />
      <path
        d="M134.461 62.858C134.596 62.9867 134.732 62.9867 134.732 63.1154C134.732 63.1154 134.732 63.1154 134.732 62.9867C134.732 62.858 134.596 62.858 134.461 62.858C134.461 62.858 134.461 62.7293 134.461 62.858Z"
        fill="#202A44"
      />
      <path
        d="M141.667 67.2459C141.531 67.1172 141.396 67.1172 141.26 67.1172C141.396 67.2459 141.531 67.2459 141.667 67.2459C141.667 67.3746 141.667 67.3746 141.667 67.2459Z"
        fill="#202A44"
      />
      <path
        d="M141.258 67.1137C140.987 66.8556 140.715 66.7266 140.307 66.7266C140.579 66.9847 140.851 67.1137 141.258 67.1137Z"
        fill="#202A44"
      />
      <path
        d="M142.889 67.8872C142.618 67.7581 142.346 67.6291 141.938 67.5C142.21 67.7581 142.482 67.7581 142.889 67.8872Z"
        fill="#202A44"
      />
      <path
        d="M138.539 66.9842C138.403 66.9842 138.403 66.8555 138.268 66.8555C138.268 66.9842 138.403 66.9842 138.539 66.9842C138.403 66.9842 138.403 66.9842 138.539 66.9842Z"
        fill="#202A44"
      />
      <path
        d="M140.443 67.6265C140.851 67.7555 141.123 67.8846 141.531 68.1427C141.531 67.8846 141.259 67.7555 141.123 67.6265C140.851 67.4974 140.579 67.4974 140.307 67.2393C139.763 66.9812 139.22 66.7231 138.812 66.465C138.676 66.465 138.54 66.3359 138.404 66.3359C138.404 66.3359 138.404 66.3359 138.404 66.465C138.54 66.594 138.812 66.7231 138.948 66.8521C139.491 66.9812 139.899 67.3684 140.443 67.6265Z"
        fill="#202A44"
      />
      <path
        d="M137.723 63.6248C137.587 63.6248 137.587 63.4961 137.452 63.4961C137.452 63.4961 137.452 63.4961 137.452 63.6248C137.587 63.6248 137.587 63.7535 137.723 63.6248C137.723 63.7535 137.723 63.7535 137.723 63.6248Z"
        fill="#202A44"
      />
      <path
        d="M138.404 64.151C138.539 64.151 138.675 64.2797 138.675 64.2797C138.675 64.151 138.539 64.0223 138.404 64.151Z"
        fill="#202A44"
      />
      <path
        d="M139.355 65.9572C139.219 65.9572 138.947 65.8281 138.811 65.8281C138.675 65.9572 138.811 66.2153 138.947 66.2153C139.219 66.3443 139.627 66.6024 140.035 66.7315C140.035 66.6024 140.035 66.3443 140.171 66.0862C140.035 65.9572 139.899 65.8281 139.627 65.9572C139.491 65.9572 139.491 65.9572 139.355 65.9572Z"
        fill="#202A44"
      />
      <path
        d="M131.197 60.2731C131.061 60.0156 130.925 60.0156 130.653 60.0156C130.925 60.2731 131.061 60.2731 131.197 60.2731Z"
        fill="#202A44"
      />
      <path
        d="M135.005 60.4048C135.685 60.792 136.364 61.0501 137.044 61.4373C137.18 61.4373 137.316 61.5663 137.452 61.5663C137.996 61.8244 138.676 62.0825 139.22 62.3406H139.356C139.22 62.2116 139.22 62.0825 139.22 62.0825C139.084 61.9535 138.948 61.9535 138.676 61.8244C138.268 61.6954 137.996 61.4373 137.724 61.1791C137.996 61.1791 138.132 61.4373 138.404 61.3082C138.132 61.1791 137.996 60.921 137.86 60.792C137.588 60.6629 137.316 60.5339 137.18 60.4048C137.044 60.1467 136.772 60.0177 136.5 60.0177C136.228 60.0177 136.093 59.7596 135.957 59.6305C135.821 59.5015 135.821 59.5015 135.685 59.6305C135.549 59.7596 135.685 59.7596 135.821 59.8886C136.093 60.0177 136.364 60.2758 136.772 60.4048C136.908 60.4048 136.908 60.5339 137.044 60.5339C136.908 60.5339 136.908 60.5339 136.772 60.5339C136.364 60.2758 135.957 60.2758 135.549 59.8886C135.549 59.8886 135.413 59.8886 135.277 59.7596C135.141 59.7596 135.141 59.6305 135.005 59.6305C134.869 59.5015 134.733 59.5015 134.461 59.3724C134.325 59.3724 134.325 59.3724 134.189 59.2434C134.053 59.1143 133.781 58.9853 133.645 58.8562C133.237 58.7271 132.829 58.469 132.557 58.2109C132.421 58.2109 132.421 58.34 132.285 58.34C132.421 58.34 132.421 58.469 132.557 58.469C133.373 59.5015 134.189 59.8886 135.005 60.4048ZM137.18 61.0501L137.316 61.1791C137.18 61.1791 137.18 61.1791 137.18 61.0501C137.18 61.0501 137.044 61.0501 137.18 61.0501Z"
        fill="#202A44"
      />
      <path
        d="M132.964 58.8512C132.964 58.8512 133.1 58.8512 133.236 58.8512C133.1 58.7225 133.1 58.7225 133.1 58.7225L132.964 58.5938C132.828 58.5938 132.828 58.7225 132.692 58.7225C132.692 58.7225 132.828 58.7225 132.964 58.8512Z"
        fill="#202A44"
      />
      <path
        d="M148.057 66.5977C147.923 66.5977 147.923 66.5977 148.057 66.5977C147.923 66.5977 147.923 66.7251 148.057 66.5977C148.057 66.7251 147.923 66.7251 148.057 66.5977C148.057 66.7251 148.057 66.7251 148.057 66.5977Z"
        fill="#202A44"
      />
      <path
        d="M134.596 59.632C134.867 59.761 135.003 60.0191 135.275 60.0191C135.139 59.761 134.867 59.5029 134.596 59.632Z"
        fill="#202A44"
      />
      <path
        d="M134.732 59.3746C134.596 59.1165 134.324 58.8584 134.052 58.9875C133.78 58.9875 133.644 58.9875 133.508 58.9875C133.78 59.2456 134.188 59.3746 134.596 59.6327C134.46 59.5037 134.324 59.3746 134.188 59.2456C134.324 59.2456 134.46 59.2456 134.732 59.3746Z"
        fill="#202A44"
      />
      <path
        d="M135.819 62.5975C135.683 62.5975 135.412 62.4688 135.276 62.4688C135.412 62.5975 135.548 62.7262 135.819 62.5975C135.819 62.7262 135.819 62.7262 135.819 62.5975Z"
        fill="#202A44"
      />
      <path
        d="M134.595 62.0781C134.459 62.0781 134.595 62.0781 134.595 62.0781C134.595 62.2068 134.73 62.2068 134.73 62.3356C134.73 62.0781 134.595 62.0781 134.595 62.0781Z"
        fill="#202A44"
      />
      <path
        d="M136.363 62.9824C136.229 62.855 136.229 62.9824 136.363 62.9824C136.229 62.855 136.229 62.9824 136.363 62.9824C136.229 62.9824 136.229 62.9824 136.363 62.9824C136.229 62.9824 136.229 62.9824 136.363 62.9824Z"
        fill="#202A44"
      />
      <path
        d="M112.159 69.3082C112.023 69.1795 111.888 69.0508 111.752 69.0508C111.752 69.0508 111.752 69.0508 111.616 69.1795C111.752 69.1795 111.888 69.3082 112.159 69.3082Z"
        fill="#202A44"
      />
      <path
        d="M112.704 69.4336H112.568C112.704 69.5626 112.84 69.5626 113.112 69.5626C113.248 69.5626 113.384 69.6917 113.656 69.6917C113.928 69.8208 114.063 69.8208 114.335 69.9498C114.335 69.9498 114.335 69.8208 114.199 69.8208C113.656 69.6917 113.248 69.5626 112.704 69.4336Z"
        fill="#202A44"
      />
      <path
        d="M131.06 62.0778C130.924 61.8203 130.788 61.8203 130.516 61.8203C130.652 61.949 130.652 62.2065 131.06 62.0778Z"
        fill="#202A44"
      />
      <path
        d="M132.829 61.8245C132.829 62.0826 132.965 62.0826 132.965 61.9536C133.237 61.8245 133.373 61.9536 133.509 62.0826C133.645 62.0826 133.645 62.2117 133.781 62.2117C134.053 62.3407 134.325 62.4698 134.597 62.5988C135.548 63.115 136.5 63.5022 137.452 64.0184C137.588 64.1475 137.724 64.1475 137.996 64.0184C137.86 64.0184 137.724 63.8894 137.588 63.8894C137.452 63.8894 137.316 63.7603 137.316 63.7603C137.18 63.7603 137.18 63.6313 137.044 63.6313C136.636 63.5022 136.228 63.2441 135.82 63.115C135.141 62.8569 134.733 62.3407 134.053 62.0826L133.917 61.9536L133.781 61.8245C133.373 61.6955 132.965 61.4374 132.557 61.1793H132.421C132.149 61.0502 131.741 60.9211 131.469 60.663C131.197 60.4049 131.197 60.4049 130.653 60.534C130.789 60.663 130.925 60.663 130.925 60.7921C131.469 61.0502 132.149 61.4374 132.693 61.6955L132.829 61.8245Z"
        fill="#202A44"
      />
      <path
        d="M136.635 63.1133C136.499 63.1133 136.499 63.1133 136.635 63.1133C136.635 63.242 136.77 63.242 136.77 63.3707C136.77 63.3707 136.77 63.3707 136.906 63.242C136.77 63.1133 136.635 63.1133 136.635 63.1133Z"
        fill="#202A44"
      />
      <path
        d="M137.315 96.152C137.315 96.152 137.315 96.0233 137.451 96.0233C137.179 96.0233 136.771 95.8945 136.499 95.8945C136.364 95.8945 136.228 95.8945 136.092 95.8945C136.092 95.8945 136.092 95.8945 136.092 96.0233C136.364 96.0233 136.771 96.152 137.315 96.152C137.179 96.152 137.179 96.152 137.315 96.152Z"
        fill="#202A44"
      />
      <path
        d="M134.188 97.8281C134.188 97.8281 134.052 97.8281 134.052 97.9572C134.732 98.0862 135.276 98.2153 135.956 98.3443L136.092 98.2153C135.82 98.2153 135.684 98.0862 135.412 98.0862C135.004 97.8281 134.596 97.8281 134.188 97.8281Z"
        fill="#202A44"
      />
      <path
        d="M123.445 72.0197C123.309 72.0197 123.037 71.8906 122.901 71.8906C122.901 72.1487 123.037 72.1487 123.173 72.2778C123.445 72.4068 123.853 72.5359 124.261 72.6649L124.397 72.5359C124.125 72.4068 123.989 72.2778 123.717 72.2778C123.581 72.2778 123.581 72.0197 123.445 72.0197Z"
        fill="#202A44"
      />
      <path
        d="M123.991 71.6333C124.126 71.7623 124.262 71.7623 124.398 71.5042C124.262 71.3751 124.126 71.3751 123.991 71.2461C123.991 71.3751 123.991 71.5042 123.991 71.6333Z"
        fill="#202A44"
      />
      <path
        d="M135.548 98.7303C135.412 98.7303 135.14 98.6016 135.004 98.6016C135.14 98.7303 135.276 98.859 135.412 98.859C135.412 98.859 135.412 98.859 135.548 98.7303Z"
        fill="#202A44"
      />
      <path
        d="M127.525 71.3714C127.389 71.1133 127.117 71.1133 126.709 71.1133C126.845 71.2423 126.981 71.3714 126.981 71.5004C127.117 71.6295 127.389 71.6295 127.525 71.6295L127.661 71.7585H127.797C127.797 71.7585 127.797 71.7585 127.797 71.6295C127.661 71.6295 127.661 71.5004 127.525 71.5004C127.661 71.5004 127.525 71.3714 127.525 71.3714Z"
        fill="#202A44"
      />
      <path
        d="M134.323 94.8631C134.188 94.7344 134.188 94.7344 134.052 94.7344C134.188 94.7344 134.323 94.7344 134.323 94.8631Z"
        fill="#202A44"
      />
      <path
        d="M133.78 95.3756C134.052 95.5046 134.46 95.6337 134.732 95.6337C135.004 95.6337 135.276 95.8918 135.684 95.7627C134.732 95.5046 133.916 95.2465 132.964 94.8594C132.964 94.8594 132.964 94.8594 132.964 94.9884C133.1 95.2465 133.508 95.2465 133.78 95.3756Z"
        fill="#202A44"
      />
      <path
        d="M135.003 99.2422C134.732 99.2422 134.596 99.2422 134.324 99.2422C134.324 99.2422 134.188 99.2422 134.052 99.2422C134.324 99.2422 134.46 99.3709 134.596 99.3709H134.732C134.868 99.3709 134.868 99.3709 135.003 99.2422Z"
        fill="#202A44"
      />
      <path
        d="M123.853 70.2109C123.853 70.2109 123.853 70.3384 123.853 70.2109C123.853 70.3384 123.987 70.3384 123.853 70.2109C123.987 70.2109 123.987 70.2109 123.853 70.2109C123.987 70.2109 123.853 70.2109 123.853 70.2109Z"
        fill="#202A44"
      />
      <path
        d="M131.74 93.0595C130.924 92.8014 130.244 92.5433 129.428 92.2852C129.428 92.2852 129.428 92.2852 129.428 92.4142C130.244 92.8014 131.06 93.0595 131.876 93.3176C131.876 93.1885 131.876 93.1885 131.74 93.0595Z"
        fill="#202A44"
      />
      <path
        d="M129.429 92.7928C129.293 92.6641 129.157 92.6641 129.021 92.6641C129.157 92.6641 129.293 92.7928 129.429 92.7928Z"
        fill="#202A44"
      />
      <path
        d="M128.069 90.8594C128.477 91.1175 128.884 91.2465 129.428 91.3756C128.884 91.2465 128.613 90.9884 128.069 90.8594Z"
        fill="#202A44"
      />
      <path
        d="M128.885 92.9258C128.885 92.9258 129.019 92.9258 129.019 93.0533C129.019 92.9258 128.885 92.9258 128.885 92.9258Z"
        fill="#202A44"
      />
      <path
        d="M123.581 72.7895C123.309 72.6605 123.037 72.5314 122.766 72.4023C122.766 72.5314 122.901 72.6604 122.901 72.6604C123.037 72.7895 123.309 73.0476 123.581 72.7895Z"
        fill="#202A44"
      />
      <path
        d="M114.607 76.0156C114.607 76.1443 114.607 76.1443 114.607 76.0156C114.607 76.1443 114.743 76.1443 114.878 76.1443C114.743 76.1443 114.743 76.1443 114.607 76.0156Z"
        fill="#202A44"
      />
      <path
        d="M116.919 72.9219C117.055 72.9219 117.191 72.9219 117.327 73.0506C117.191 72.9219 117.191 72.9219 116.919 72.9219Z"
        fill="#202A44"
      />
      <path
        d="M125.078 77.1793C124.806 77.0506 124.399 77.0506 123.991 76.9219V77.0506C124.399 77.0506 124.67 77.1793 125.078 77.1793Z"
        fill="#202A44"
      />
      <path
        d="M120.59 76.4061C120.454 76.4061 120.318 76.2773 120.183 76.2773V76.4061C120.318 76.4061 120.454 76.5348 120.59 76.4061C120.59 76.5348 120.59 76.4061 120.59 76.4061Z"
        fill="#202A44"
      />
      <path
        d="M126.843 83.2461C126.709 83.2461 126.843 83.2461 126.843 83.2461C126.709 83.2461 126.709 83.2461 126.709 83.2461C126.709 83.3736 126.709 83.3736 126.843 83.2461C126.843 83.3736 126.709 83.3736 126.843 83.2461Z"
        fill="#202A44"
      />
      <path
        d="M125.486 83.6365C125.35 83.6365 125.214 83.5078 125.078 83.5078C125.35 83.5078 125.35 83.6365 125.486 83.6365Z"
        fill="#202A44"
      />
      <path
        d="M118.686 71.2461C118.686 71.2461 118.82 71.2461 118.82 71.3736C118.82 71.3736 118.82 71.2461 118.686 71.2461Z"
        fill="#202A44"
      />
      <path
        d="M120.59 71.6326C120.454 71.5039 120.318 71.5039 120.183 71.5039C120.318 71.6326 120.318 71.6326 120.59 71.6326Z"
        fill="#202A44"
      />
      <path
        d="M120.863 72.793C121.678 73.1801 122.358 73.1801 123.174 73.1801C122.494 72.922 121.678 72.922 120.863 72.793Z"
        fill="#202A44"
      />
      <path
        d="M120.318 73.8247C119.774 73.6956 119.366 73.4375 118.823 73.4375C119.366 73.5666 119.774 73.8247 120.318 73.8247Z"
        fill="#202A44"
      />
      <path
        d="M118.55 73.3084C118.414 73.1797 118.279 73.1797 118.143 73.1797V73.3084C118.279 73.3084 118.279 73.4371 118.55 73.3084Z"
        fill="#202A44"
      />
      <path
        d="M145.474 71.6337C145.61 71.5046 145.61 71.3756 145.882 71.2465C145.338 71.1175 144.93 70.8594 144.386 70.8594C144.658 71.3756 145.202 71.3756 145.474 71.6337Z"
        fill="#202A44"
      />
      <path
        d="M121.542 67.3746C121.677 67.2459 121.677 67.2459 121.542 67.1172C121.406 67.1172 121.134 67.1172 120.998 67.1172C121.27 67.1172 121.406 67.2459 121.542 67.3746Z"
        fill="#202A44"
      />
      <path
        d="M138.132 64.7933C138.404 64.9223 138.676 65.0514 138.812 65.1804C139.356 65.4385 139.9 65.6966 140.308 65.9547C140.444 65.9547 140.444 66.0838 140.58 65.9547C140.58 65.8257 140.444 65.6966 140.308 65.6966C139.9 65.5676 139.492 65.3095 139.084 65.1804C139.084 65.1804 138.948 65.1804 138.948 65.0514C138.54 64.9223 138.268 64.7933 137.86 64.5352C137.996 64.7933 137.996 64.7933 138.132 64.7933Z"
        fill="#202A44"
      />
      <path
        d="M137.858 64.6606C137.586 64.5315 137.45 64.2734 137.043 64.2734C137.315 64.5315 137.45 64.5315 137.858 64.6606Z"
        fill="#202A44"
      />
      <path
        d="M141.257 69.6939C141.257 69.5664 141.257 69.6939 141.257 69.6939C141.257 69.5664 141.123 69.5664 141.123 69.5664C141.123 69.5664 141.257 69.6939 141.257 69.6939Z"
        fill="#202A44"
      />
      <path
        d="M142.347 82.733C142.483 82.733 142.619 82.8617 142.755 82.8617C142.755 82.8617 142.755 82.8617 142.755 82.733C142.619 82.733 142.483 82.733 142.347 82.733C142.347 82.733 142.347 82.6043 142.347 82.733Z"
        fill="#202A44"
      />
      <path
        d="M135.684 68.5338C135.82 68.5338 135.956 68.6625 136.092 68.6625C136.092 68.6625 136.092 68.6625 136.092 68.5338C136.092 68.5338 135.956 68.4051 135.684 68.5338Z"
        fill="#202A44"
      />
      <path
        d="M136.636 65.5629C136.364 65.4339 136.092 65.1758 135.548 65.1758C135.956 65.5629 136.908 66.0792 137.452 66.0792C137.316 65.821 137.044 65.692 136.636 65.5629Z"
        fill="#202A44"
      />
      <path
        d="M136.228 65.9511C136.092 65.8221 135.956 65.693 135.82 65.693C135.276 65.4349 134.732 65.1768 134.188 64.7897C133.78 64.5315 133.372 64.2734 132.828 64.2734C133.916 64.9187 135.14 65.4349 136.228 65.9511C136.092 65.9511 136.092 65.9511 136.228 65.9511C136.228 65.9511 136.092 65.9511 136.228 65.9511Z"
        fill="#202A44"
      />
      <path
        d="M137.45 66.4684C137.315 66.3397 137.179 66.3397 137.043 66.2109C137.043 66.4684 137.315 66.4684 137.45 66.4684Z"
        fill="#202A44"
      />
      <path
        d="M137.724 66.3418L137.858 66.4693C137.858 66.4693 137.858 66.4693 137.858 66.3418C137.858 66.3418 137.858 66.3418 137.724 66.3418C137.724 66.3418 137.724 66.2143 137.724 66.3418Z"
        fill="#202A44"
      />
      <path
        d="M137.043 66.2107C136.908 66.2107 136.772 66.082 136.5 66.082C136.636 66.2107 136.772 66.3395 137.043 66.2107Z"
        fill="#202A44"
      />
      <path
        d="M144.114 70.7289C143.706 70.4715 143.706 70.4715 143.57 70.6002C143.706 70.7289 143.842 70.7289 144.114 70.7289Z"
        fill="#202A44"
      />
      <path
        d="M137.314 89.5668C137.314 89.5668 137.449 89.5668 137.314 89.5668C137.314 89.4378 137.178 89.3087 137.043 89.1797C137.043 89.3087 137.178 89.4378 137.314 89.5668Z"
        fill="#202A44"
      />
      <path
        d="M135.275 87.5035C135.14 87.3748 135.14 87.2461 135.004 87.2461C135.004 87.3748 135.004 87.3748 135.275 87.5035Z"
        fill="#202A44"
      />
      <path
        d="M137.722 90.4723C137.722 90.3436 137.722 90.3436 137.587 90.2148C137.451 90.4723 137.587 90.4723 137.722 90.4723Z"
        fill="#202A44"
      />
      <path
        d="M140.851 83.1168C140.716 82.9881 140.716 82.9881 140.58 82.8594C140.58 82.9881 140.716 82.9881 140.851 83.1168C140.851 83.1168 140.716 83.1168 140.851 83.1168Z"
        fill="#202A44"
      />
      <path
        d="M134.596 86.9844C134.732 87.1131 134.867 87.1131 135.003 87.2418C134.867 87.1131 134.732 86.9844 134.596 86.9844Z"
        fill="#202A44"
      />
      <path
        d="M142.075 85.1783C141.939 85.0492 141.939 85.0492 141.803 84.9202C141.939 84.9202 141.939 84.9202 142.075 84.7911C142.211 84.533 142.211 84.2749 142.211 84.0168C141.803 83.6296 141.396 83.2425 141.124 82.9844C140.852 83.1134 140.58 82.9844 140.444 83.1134C140.444 83.1134 140.444 83.1134 140.444 83.2425C140.58 83.3715 140.716 83.5006 140.852 83.6296C141.26 83.6296 141.532 83.7587 141.939 83.8878C141.939 83.8878 142.075 83.8877 142.075 84.0168C141.939 84.0168 141.939 84.0168 141.803 84.0168C141.668 84.0168 141.396 84.0168 141.26 84.0168C141.532 84.2749 141.803 84.533 142.075 84.7911C141.939 84.7911 141.803 84.7911 141.668 84.7911C141.396 84.533 141.124 84.2749 140.852 84.0168C140.716 84.0168 140.58 84.0168 140.58 84.0168C140.852 84.2749 141.124 84.533 141.396 84.7911C141.26 84.7911 140.988 84.9202 140.852 84.9202C141.124 85.0492 141.396 85.0492 141.532 85.0492C141.668 85.1783 141.803 85.3073 141.939 85.4364C142.075 85.3073 142.075 85.3073 142.075 85.1783Z"
        fill="#202A44"
      />
      <path
        d="M139.763 81.9573C139.627 81.8283 139.491 81.8283 139.355 81.6992C139.355 81.6992 139.355 81.6992 139.22 81.8283C139.491 81.8283 139.491 81.9573 139.763 81.9573C139.763 82.0864 139.627 82.0864 139.763 81.9573Z"
        fill="#202A44"
      />
      <path
        d="M130.924 91.5035C130.924 91.2461 130.652 91.2461 130.516 91.2461C130.652 91.2461 130.788 91.3748 130.924 91.5035Z"
        fill="#202A44"
      />
      <path
        d="M129.701 91.5039C129.973 91.6326 130.109 91.6326 130.38 91.7614C130.245 91.6326 129.973 91.5039 129.701 91.5039Z"
        fill="#202A44"
      />
      <path
        d="M131.059 90.729C131.059 90.729 130.925 90.729 130.925 90.6016C130.925 90.729 131.059 90.729 131.059 90.729Z"
        fill="#202A44"
      />
      <path
        d="M132.692 91.8906C132.964 91.8906 133.1 92.0197 133.372 92.0197C133.644 92.0197 133.78 92.1487 134.052 92.2778C133.508 92.0197 132.964 91.8906 132.692 91.8906Z"
        fill="#202A44"
      />
      <path
        d="M131.605 91.5039C131.741 91.6326 131.877 91.6326 132.013 91.7614C131.877 91.5039 131.741 91.5039 131.605 91.5039Z"
        fill="#202A44"
      />
      <path
        d="M131.196 63.3789C131.468 63.637 131.603 63.7661 131.875 63.7661C131.739 63.508 131.603 63.508 131.332 63.3789H131.196Z"
        fill="#202A44"
      />
      <path
        d="M113.792 68.5352C113.927 68.5352 113.927 68.6639 114.062 68.6639C114.062 68.5352 113.927 68.5352 113.792 68.5352C113.927 68.5352 113.927 68.5352 113.792 68.5352Z"
        fill="#202A44"
      />
      <path
        d="M115.014 69.0506C114.878 69.0506 114.878 68.9219 114.878 68.9219H114.743C114.743 68.9219 114.743 69.0506 115.014 69.0506Z"
        fill="#202A44"
      />
      <path
        d="M116.238 69.6923C116.106 69.6923 116.238 69.5672 116.238 69.6923C116.106 69.6923 116.238 69.6923 116.238 69.6923Z"
        fill="#202A44"
      />
      <path
        d="M115.831 69.4379C115.695 69.3089 115.559 69.1798 115.287 69.0508C115.287 69.0508 115.287 69.0508 115.287 69.1798C115.423 69.3089 115.559 69.4379 115.831 69.4379Z"
        fill="#202A44"
      />
      <path
        d="M117.599 68.7891L117.733 68.9165C117.733 68.9165 117.733 68.9165 117.599 68.7891C117.733 68.7891 117.599 68.7891 117.599 68.7891Z"
        fill="#202A44"
      />
      <path
        d="M110.665 71.112C111.073 71.2411 111.345 71.3701 111.753 71.4992C112.841 71.8864 113.928 72.1445 115.016 72.4026C115.424 72.5316 115.832 72.6607 116.24 72.7897C116.376 72.7897 116.648 72.7897 116.784 72.9188C116.376 72.5316 112.433 71.3702 110.665 71.112C110.665 71.112 110.665 70.983 110.665 71.112Z"
        fill="#202A44"
      />
      <path
        d="M139.491 62.5946C139.627 62.5946 139.763 62.7237 139.899 62.7237C140.443 62.9818 140.987 63.2399 141.667 63.627C141.939 63.7561 142.211 63.8852 142.483 64.0142C143.027 64.2723 143.571 64.5304 144.115 64.7885C144.523 64.9176 144.795 65.0466 145.202 65.1757C145.882 65.4338 146.562 65.8209 147.242 66.0791C147.514 66.2081 147.786 66.3372 148.058 66.3372C147.922 66.0791 147.786 65.8209 147.514 65.4338C147.378 65.4338 147.242 65.3047 147.242 65.3047C146.97 65.1757 146.562 65.0466 146.29 64.9176C146.29 64.9176 146.154 64.9176 146.018 64.9176C146.154 65.0466 146.29 65.1757 146.426 65.3047C146.562 65.3047 146.562 65.4338 146.562 65.4338C146.698 65.4338 146.834 65.4338 146.97 65.5628C146.834 65.5628 146.698 65.4338 146.562 65.4338C146.29 65.3047 146.018 65.1757 145.746 65.1757C145.474 65.0466 145.202 64.9176 144.931 64.7885C145.066 64.7885 145.338 64.7885 145.474 64.9176C145.067 64.5304 143.163 63.627 142.755 63.627C142.891 63.7561 143.027 63.8852 143.163 63.8852C143.435 64.0142 143.707 64.1433 143.843 64.2723C143.979 64.2723 143.979 64.4014 144.115 64.5304C144.387 64.5304 144.659 64.6595 144.931 64.9176C144.659 64.9176 144.387 64.7885 144.115 64.5304C143.979 64.4014 143.707 64.4014 143.571 64.2723C143.163 64.1433 142.755 63.8852 142.347 63.627C142.211 63.627 142.211 63.498 142.075 63.3689C141.803 63.3689 141.667 63.2399 141.395 63.1108C141.667 63.1108 141.939 63.2399 142.075 63.3689C142.211 63.3689 142.211 63.3689 142.347 63.3689C142.211 63.2399 142.075 63.1108 141.939 62.9818C141.395 62.7237 140.851 62.4656 140.443 62.2075C140.307 62.2075 140.307 62.2075 140.171 62.0784C139.899 61.9494 139.763 61.9494 139.491 61.8203H139.355C139.491 62.0784 139.627 62.0784 139.899 62.2075C140.035 62.3365 140.307 62.3365 140.443 62.5946C140.579 62.5946 140.715 62.7237 140.851 62.8527C140.715 62.7237 140.579 62.7237 140.443 62.5946C139.899 62.5946 139.763 62.5946 139.491 62.5946ZM147.242 65.6919C147.242 65.6919 147.242 65.8209 147.242 65.6919C147.242 65.8209 147.242 65.8209 147.242 65.6919C147.106 65.8209 147.106 65.6919 147.242 65.6919Z"
        fill="#202A44"
      />
      <path
        d="M115.967 70.3359C115.967 70.4634 116.101 70.4634 116.101 70.4634C116.101 70.4634 116.101 70.4634 116.101 70.3359C116.101 70.3359 116.101 70.3359 115.967 70.3359Z"
        fill="#202A44"
      />
      <path
        d="M144.25 63.1131C144.115 63.1131 144.115 62.9844 143.979 62.9844C143.979 63.1131 143.979 63.1131 144.25 63.1131Z"
        fill="#202A44"
      />
      <path
        d="M114.2 68.668C114.336 68.7967 114.472 68.7967 114.608 68.9254C114.472 68.7967 114.336 68.7967 114.2 68.668Z"
        fill="#202A44"
      />
      <path
        d="M129.701 65.3086C129.701 65.5667 129.837 65.5667 129.973 65.6958C130.109 65.8248 130.245 65.8248 130.381 65.9539C130.517 66.0829 130.653 66.212 130.789 66.0829C130.517 65.6957 130.109 65.4376 129.701 65.3086Z"
        fill="#202A44"
      />
      <path
        d="M130.38 63.1123C130.516 63.2413 130.652 63.2413 130.788 63.3704C130.788 63.3704 130.924 63.3704 131.06 63.3704V63.2413C131.06 63.1123 130.924 62.9832 130.924 62.9832C130.652 62.8542 130.38 62.8542 130.38 63.1123Z"
        fill="#202A44"
      />
      <path
        d="M135.14 68.2754C135.274 68.2754 135.274 68.2754 135.274 68.2754C135.274 68.2754 135.274 68.1479 135.14 68.2754C135.14 68.2754 135.14 68.1479 135.14 68.2754Z"
        fill="#202A44"
      />
      <path
        d="M121.95 67.5001C122.085 67.6292 122.085 67.6292 122.357 67.7582C122.357 67.5001 122.221 67.3711 122.085 67.3711H121.95C121.814 67.3711 121.814 67.3711 121.95 67.5001Z"
        fill="#202A44"
      />
      <path
        d="M134.189 68.9219C134.325 69.1793 134.596 69.1793 134.868 69.1793C134.596 69.0506 134.46 68.9219 134.189 68.9219Z"
        fill="#202A44"
      />
      <path
        d="M134.596 68.7891C134.596 68.9165 134.73 68.9165 134.73 68.9165C134.73 68.7891 134.596 68.7891 134.596 68.7891Z"
        fill="#202A44"
      />
      <path
        d="M135.546 69.5611C135.546 69.4336 135.412 69.4336 135.412 69.4336C135.412 69.5611 135.546 69.5611 135.546 69.5611Z"
        fill="#202A44"
      />
      <path
        d="M130.516 66.9872C130.652 66.9872 130.788 67.1159 130.924 66.9872C130.652 66.8584 130.652 66.8584 130.516 66.9872Z"
        fill="#202A44"
      />
      <path
        d="M127.389 65.3043C127.389 65.1756 127.254 65.1756 127.254 65.0469C127.254 65.0469 127.254 65.0469 127.254 65.1756C127.254 65.1756 127.389 65.3043 127.389 65.3043Z"
        fill="#202A44"
      />
      <path
        d="M132.284 63.5012C132.284 63.3721 132.284 63.3721 132.284 63.5012C131.74 63.114 131.196 62.8559 130.516 62.4688C130.652 62.5978 130.652 62.7269 130.788 62.8559C130.924 62.8559 131.06 62.985 131.196 62.985C131.468 63.114 131.74 63.2431 132.012 63.3721C132.148 63.3721 132.284 63.3721 132.284 63.5012Z"
        fill="#202A44"
      />
      <path
        d="M129.293 61.8203C129.701 62.0784 130.109 62.3365 130.517 62.4656C130.381 62.4656 130.245 62.3365 130.245 62.3365C129.837 62.0784 129.565 61.8203 129.293 61.8203Z"
        fill="#202A44"
      />
      <path
        d="M139.898 61.9511C139.764 61.8236 139.898 61.8236 139.898 61.9511C139.764 61.8236 139.764 61.8236 139.898 61.9511C139.764 61.9511 139.764 61.9511 139.898 61.9511Z"
        fill="#202A44"
      />
      <path
        d="M113.419 175.291C113.419 175.291 131.118 157.776 131.118 145.258L133.78 155.907C133.916 155.778 128.104 169.225 113.419 175.291Z"
        fill="#1B365D"
        class="fill-primary-800"
      />
      <path
        d="M87.6828 156.935H87.8188H107.671C108.079 156.935 108.351 156.677 108.351 156.29C108.351 155.903 108.079 155.645 107.671 155.645H87.8188C87.4109 155.645 87.1389 155.903 87.1389 156.29C87.2749 156.548 87.4109 156.806 87.6828 156.935Z"
        fill="#CED9E5"
        class="fill-primary-200"
      />
      <path
        d="M88.3648 162.224H88.5008H108.353C108.761 162.224 109.033 161.966 109.033 161.579C109.033 161.192 108.761 160.934 108.353 160.934H88.5008C88.0929 160.934 87.8209 161.192 87.8209 161.579C87.9569 161.837 88.0929 162.095 88.3648 162.224Z"
        fill="#CED9E5"
        class="fill-primary-200"
      />
      <path
        d="M88.2284 167.396H88.3643H108.217C108.625 167.396 108.897 167.138 108.897 166.751C108.897 166.364 108.625 166.105 108.217 166.105H88.3643C87.9564 166.105 87.6844 166.364 87.6844 166.751C87.8204 167.009 87.9564 167.267 88.2284 167.396Z"
        fill="#CED9E5"
        class="fill-primary-200"
      />
      <path
        d="M88.365 172.552H88.5009H108.354C108.761 172.552 109.033 172.294 109.033 171.907C109.033 171.52 108.761 171.262 108.354 171.262H88.5009C88.093 171.262 87.821 171.52 87.821 171.907C87.957 172.294 88.093 172.552 88.365 172.552Z"
        fill="#CED9E5"
        class="fill-primary-200"
      />
    </g>
    <path
      opacity="0.1"
      d="M115.046 96.4552C115.807 96.8625 116.28 97.5647 116.365 98.2277C121.236 100.553 125.411 98.5189 125.645 98.4193C126.137 98.1775 126.749 98.3365 127.048 98.8332C127.302 99.3059 127.138 99.892 126.62 100.177C126.386 100.276 121.202 102.837 115.28 99.8937C114.653 100.064 113.922 100.009 113.205 99.6259C112.041 99.003 111.523 97.7714 112.02 96.9144C112.543 96.0146 113.881 95.8322 115.046 96.4552Z"
      fill="#1D1A2F"
    />
    <path
      d="M115.079 99.4805C121.215 102.763 126.586 100.077 126.82 99.9779C127.312 99.7359 127.501 99.1068 127.247 98.634C126.993 98.1611 126.336 97.9782 125.844 98.2202C125.61 98.3198 120.383 100.858 114.689 96.9135C114.221 96.607 113.575 96.7103 113.281 97.115C112.963 97.5625 113.073 98.1828 113.496 98.4653C114.029 98.8625 114.541 99.193 115.079 99.4805Z"
      fill="#1D1A2F"
    />
    <path
      d="M127.252 99.0296C126.998 98.5565 126.342 98.3735 125.849 98.6157C125.616 98.7153 120.391 101.255 114.7 97.3087C114.232 97.0021 113.586 97.1055 113.293 97.5103C113.218 97.639 113.144 97.7677 113.114 97.9203C113.034 97.6529 113.094 97.3476 113.288 97.1142C113.606 96.6665 114.252 96.5631 114.695 96.9126C120.341 100.835 125.611 98.3192 125.844 98.2196C126.336 97.9774 126.948 98.1364 127.247 98.6335C127.351 98.858 127.411 99.0586 127.332 99.297C127.337 99.1873 127.317 99.1204 127.252 99.0296Z"
      fill="#363C45"
    />
    <path
      d="M113.61 97.9603C114.123 98.2908 114.635 98.6214 115.172 98.909C121.306 102.193 126.675 99.5059 126.909 99.4062C127.142 99.3066 127.311 99.1162 127.366 98.9207C127.416 99.3407 127.237 99.7506 126.839 99.931C126.581 100.073 121.192 102.694 115.103 99.4338C114.61 99.1701 114.098 98.8395 113.541 98.485C113.163 98.2264 113.048 97.7155 113.227 97.3056C113.237 97.5919 113.342 97.8164 113.61 97.9603Z"
      fill="#1D1A2F"
    />
    <path
      d="M112.223 96.6293C111.724 97.4839 112.243 98.7118 113.411 99.3326C114.58 99.9535 115.947 99.7285 116.446 98.874C116.945 98.0194 116.426 96.7915 115.258 96.1707C114.09 95.5498 112.747 95.732 112.223 96.6293Z"
      fill="#1D1A2F"
    />
    <path
      d="M115.186 96.4237C114.023 95.8001 112.686 95.9828 112.165 96.8837C112.215 96.7979 112.195 96.731 112.244 96.6452C112.74 95.7872 114.102 95.5617 115.266 96.1852C116.429 96.8088 116.948 98.0417 116.451 98.8997C116.764 98.0556 116.216 96.9754 115.186 96.4237Z"
      fill="#2E333B"
    />
    <path
      d="M113.676 98.8587C114.751 99.4343 115.948 99.2895 116.529 98.5893C116.48 98.6751 116.5 98.742 116.45 98.8278C115.954 99.6857 114.592 99.9113 113.428 99.2877C112.265 98.6641 111.747 97.4312 112.243 96.5733C112.292 96.4875 112.317 96.4446 112.412 96.3828C112.074 97.2698 112.647 98.3071 113.676 98.8587Z"
      fill="#1D1A2F"
    />
    <path
      d="M110.611 67.8914C119.648 65.2561 129.356 71.1808 129.695 71.8113C137.533 78.0273 136.175 87.8609 134.735 91.8647C134.267 92.064 133.715 92.1056 133.197 91.8849C132.227 91.5343 131.769 90.5027 132.132 89.5733C132.211 89.335 136.225 79.5745 128.427 73.4923C128.566 72.9487 118.539 66.9911 110.665 70.8628C113.29 69.7044 110.83 70.7821 110.665 70.8628C110.968 68.7216 109.124 68.8372 110.611 67.8914Z"
      fill="#F49A22"
    />
    <path
      d="M134.744 91.8772C136.129 88.0682 137.387 78.9102 130.649 72.7198C130.341 72.4423 129.326 71.5619 128.858 71.2554C126.271 69.646 118.027 65.8519 110.434 68.0236C110.811 67.7764 111.209 67.5961 111.562 67.3918C118.768 65.6867 126.251 69.0734 128.907 70.6639C129.465 71.0183 130.704 72.0185 131.032 72.3629C137.805 78.7967 136.283 88.2069 134.838 91.8154L134.813 91.8583C134.768 91.8343 134.768 91.8343 134.744 91.8772Z"
      fill="#2E333B"
    />
    <path
      d="M110.64 69.8339C116.657 66.2311 123.591 70.2342 127.144 72.3038C128.015 72.8259 129.513 74.1892 129.906 74.6244C135.729 80.7738 132.182 89.3242 132.102 89.5626C131.74 90.492 132.198 91.5236 133.143 91.9171C133.661 92.1378 134.213 92.0962 134.68 91.897C134.631 91.9827 134.626 92.0925 134.576 92.1782C134.357 92.4544 134.119 92.6637 133.771 92.7583C133.676 92.8201 133.562 92.8151 133.492 92.834C133.492 92.834 133.422 92.8529 133.378 92.8289C133.308 92.8478 133.194 92.8428 133.124 92.8617C133.054 92.8806 133.01 92.8567 132.965 92.8327C132.92 92.8087 132.85 92.8277 132.806 92.8037C132.691 92.7986 132.557 92.7268 132.442 92.7217C131.472 92.3711 131.014 91.3395 131.377 90.41C131.456 90.1717 135.053 81.5355 129.066 75.4668C128.648 75.0745 127.304 73.8499 126.478 73.3518C122.965 71.4159 118.099 67.7043 110.588 70.8516C110.593 70.7419 110.635 69.9436 110.64 69.8339Z"
      fill="#C37B1B"
    />
    <path
      d="M126.307 94.0593C124.575 96.9939 124.798 100.231 126.878 101.325C128.914 102.395 131.992 100.892 133.724 97.9579C135.456 95.0233 135.143 91.7383 133.107 90.6685C131.072 89.5988 128.038 91.1247 126.307 94.0593Z"
      fill="#1D1A2F"
    />
    <path
      d="M131.094 90.3756C129.701 90.9255 128.278 92.1279 127.323 93.7428C125.589 96.675 125.812 99.9098 127.896 101.002C128.53 101.335 129.2 101.407 129.924 101.286C128.838 101.719 127.771 101.716 126.865 101.241C124.826 100.172 124.558 96.9138 126.292 93.9815C127.518 92.0079 129.389 90.6505 131.094 90.3756Z"
      fill="#1D1A2F"
    />
    <path
      d="M128.859 95.4234C127.704 97.3796 127.836 99.5661 129.238 100.303C130.641 101.04 132.635 99.9708 133.789 98.0146C134.944 96.0584 134.812 93.8718 133.41 93.1349C132.007 92.3979 130.013 93.4672 128.859 95.4234Z"
      fill="#F49A22"
    />
    <path
      d="M131.253 93.1636C130.701 93.5977 130.214 94.122 129.813 94.8027C128.659 96.7598 128.791 98.9473 130.192 99.6846C130.825 100.018 131.613 99.9865 132.346 99.6474C131.292 100.431 130.122 100.707 129.218 100.231C127.862 99.5178 127.66 97.349 128.839 95.3494C129.486 94.3522 130.354 93.5827 131.253 93.1636Z"
      fill="#C37B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M190.351 28.5078L106.719 7.24048C98.5929 5.17416 90.159 10.0402 87.8809 18.109C85.6027 26.1779 90.3431 34.394 98.4688 36.4604L152.675 50.2449C168.927 54.3775 185.795 44.6455 190.351 28.5078Z"
      fill="#1B365D"
      class="fill-primary-800"
      fill-opacity="0.5"
    />
    <path
      d="M103.868 16.7955L172.35 34.0144C173.347 34.265 174.336 33.6694 174.576 32.6742C174.816 31.679 174.211 30.6823 173.214 30.4317L104.732 13.2128C103.735 12.9621 102.745 13.5578 102.505 14.553C102.266 15.5482 102.871 16.5448 103.868 16.7955Z"
      fill="white"
    />
    <path
      d="M102.125 23.5455L170.607 40.7644C171.604 41.015 172.593 40.4194 172.833 39.4242C173.073 38.429 172.467 37.4323 171.47 37.1817L102.988 19.9628C101.991 19.7121 101.002 20.3078 100.762 21.3029C100.522 22.2981 101.128 23.2948 102.125 23.5455Z"
      fill="white"
    />
    <path
      d="M100.081 30.1691L133.304 38.4756C134.301 38.7251 135.295 38.1384 135.539 37.1557C135.783 36.1729 135.181 35.1872 134.183 34.9377L100.96 26.6312C99.9621 26.3818 98.9685 26.9684 98.7243 27.9512C98.4801 28.9339 99.0829 29.9197 100.081 30.1691Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M228.319 98.7617L176.889 98.7617C168.54 98.7617 161.772 105.53 161.772 113.879C161.772 122.228 168.54 128.996 176.889 128.996L198.085 128.996C214.783 128.996 228.319 115.46 228.319 98.7617Z"
      fill="#1B365D"
      class="fill-primary-800"
    />
    <g opacity="0.5">
      <path
        d="M171.588 108.58L217.877 108.58C218.551 108.58 219.09 107.797 219.09 106.819C219.09 105.841 218.551 105.059 217.877 105.059L171.588 105.059C170.914 105.059 170.375 105.841 170.375 106.819C170.375 107.797 170.914 108.58 171.588 108.58Z"
        fill="white"
      />
      <path
        d="M171.688 115.525L217.978 115.525C218.651 115.525 219.19 114.743 219.19 113.764C219.19 112.786 218.651 112.004 217.978 112.004L171.688 112.004C171.015 112.004 170.476 112.786 170.476 113.764C170.476 114.743 171.015 115.525 171.688 115.525Z"
        fill="white"
      />
      <path
        d="M171.587 122.466L194.024 122.466C194.698 122.466 195.237 121.684 195.237 120.706C195.237 119.728 194.698 118.945 194.024 118.945L171.587 118.945C170.914 118.945 170.375 119.728 170.375 120.706C170.375 121.684 170.914 122.466 171.587 122.466Z"
        fill="white"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.3364 85.4834L69.0447 71.2026C74.4113 68.3331 81.236 70.2668 84.2882 75.5215C87.3404 80.7763 85.4643 87.3623 80.0977 90.2317L71.6021 94.7743C61.5435 100.153 48.7518 96.5283 43.0311 86.6793L42.3364 85.4834Z"
      fill="#1B365D"
      class="fill-primary-800"
      fill-opacity="0.5"
    />
    <ellipse
      cx="2.34105"
      cy="2.27357"
      rx="2.34105"
      ry="2.27357"
      transform="matrix(0.883419 -0.469759 0.507247 0.860987 55.509 88.0039)"
      fill="white"
    />
    <ellipse
      cx="2.34105"
      cy="2.27357"
      rx="2.34105"
      ry="2.27357"
      transform="matrix(0.883419 -0.469759 0.507247 0.860987 62.3159 84.2695)"
      fill="white"
    />
    <ellipse
      cx="2.34105"
      cy="2.27357"
      rx="2.34105"
      ry="2.27357"
      transform="matrix(0.883419 -0.469759 0.507247 0.860987 69.1244 80.543)"
      fill="white"
    />
  </svg>
</template>
